/**
 * Status em que o processo arbitral terminou: espelha `ESTADOS_TERMINAIS` de
 * `statusArbitralMachine.ts` no core. Mora aqui, num lugar só, porque as cópias por feature
 * já divergiram uma vez: uma delas esqueceu o `CANCELADO` (ClickUp 86ak6vee4), e a aba de
 * pendências deixava resolver pendência de processo `NEGADO` (A-18 do smoke v560).
 */
export const ESTADOS_TERMINAIS_ARBITRAL = ['CONCLUIDO', 'NEGADO', 'CANCELADO'] as const;

const TERMINAIS: ReadonlySet<string> = new Set(ESTADOS_TERMINAIS_ARBITRAL);

/**
 * Diz se o `statusArbitral` é terminal. Status ausente ou desconhecido conta como NÃO terminal:
 * a tela mostra a ação e o core, que é a autoridade, recusa. Esconder por engano seria pior
 * (some a ação sem explicação).
 *
 * @example
 * ehStatusArbitralTerminal('NEGADO'); // true
 * ehStatusArbitralTerminal(undefined); // false
 */
export function ehStatusArbitralTerminal(status: string | null | undefined): boolean {
  return status != null && TERMINAIS.has(status);
}
